module.exports = __webpack_public_path__ + "img/image26.277003a9.webp";